import { importScript, setToken, getToken, storage } from "@/CommonDP/utils";
import keyCatalog from "@/CommonDP/service/folder-service";
import loginService from "@/CommonDP/service/login-service";
import treeUtils from "@/CommonDP/utils/treeUtils";
async function setUserState(next, to, isInitSysAuth) {
  const {
    query: { token: _token, enterpriseId: _enterpriseId, prjId: _prjId }
  } = to;
  const store = require("@/store/index").default;
  // 删除流程id
  storage.remove("flowId");
  let userInfo = store.state.user.userInfo;
  if (_token) {
    if (_token !== getToken()) store.dispatch("setUserInfo", {}); // 切换token,清空用户信息
    setToken(_token);
    const { data } = await store.dispatch("GetUserInfo");
    userInfo = data;
    store.dispatch("setEnterpriseId", _enterpriseId || data.currentEnterpriseId);
    store.dispatch("setUnauthorized", 1);
    delete to.query.token;
    next({ ...to, replace: true });
  } else {
    const permissionList = [];
    if (_prjId) {
      const updatePrj = {
        prjId: _prjId
      };
      permissionList.push(store.dispatch("updatePrj", updatePrj));
    }
    const enterpriseId = _enterpriseId || userInfo.currentEnterpriseId;
    if (isInitSysAuth) {
      permissionList.push(
        store.dispatch("GetModuleList", enterpriseId)
      );
    }
    await Promise.all(permissionList);
  }
}
// 设置是否为app的webview调用
function setWebView(to) {
  const {
    query: { isWebView }
  } = to;
  if (isWebView) {
    const store = require("@/store/index").default;
    store.dispatch("setWebView", isWebView);
  }
}

export async function beforeEnterCad(_to, _from, next) {
  const store = require("@/store/index").default;
  // 获取url上的token
  await setUserState(next, _to);
  try {
    if (getToken()) {
      if (_to.path?.includes("/approvalCAD") || _to.path?.includes("/approvalRVT")) {
        await store.dispatch("getModuleProjectList");
      }
      next();
    } else {
      throw new Error("");
    }
  } catch (error) {
    next({ name: "login" });
  }
  next();
}

export async function beforeEnterBimex(_to, _from, next) {
  // 获取url上的token
  const {
    query: { sharerId }
  } = _to;
  await setUserState(next, _to);

  try {
    await Promise.all([importScript("./Monge.js")]);
    if (getToken()) {
      next();
    } else {
      throw new Error("");
    }
  } catch (error) {
    if (!sharerId) {
      next({ name: "login" });
    }
  }
  next();
}

export async function beforeEnterPrintDesign(_to, _from, next) {
  // 获取url上的token
  const {
    query: { sharerId }
  } = _to;
  await setUserState(next, _to);

  try {
    if (getToken()) {
      next();
    } else {
      throw new Error("");
    }
  } catch (error) {
    if (!sharerId) {
      next({ name: "login" });
    }
  }
  next();
}
export function getWhiteList(routes) {
  const _temp = [];
  routes.forEach((route) => {
    if (route.name !== "mainMg") {
      _temp.push(route);
    }
  });
  const whiteList = [];
  treeUtils.wtravelAll(_temp, false, (item, index, arr) => {
    whiteList.push(item);
  });
  return whiteList;
}
export async function beforeEnterCmmon(to, _from, next) {
  setWebView(to);
  await setUserState(next, to, true);
  try {
    if (getToken()) {
      next();
    } else {
      throw new Error("");
    }
  } catch (error) {
    next({ name: "login" });
  }
  next();
}

export async function beforeEnterRegister(to, _from, next) {
  if (_from.path === "/consentagree") {
    storage.set("stepsIndex", 2);
  } else {
    storage.set("stepsIndex", 0);
  }
  next();
}
export async function beforeEnterPassword(to, _from, next) {
  storage.set("stepsIndex2", 0);
  next();
}

export async function beforeEachproject(to, _from, next) {
  const { path, matched } = to;
  const { matched: _matched } = _from;
  // 初始化界面 拦截项目目下所有界面（除了策划界面）
  const isBlock = path.includes("/project-setup") ? false : matched.some(({ path }) => path.includes("/project"));
  const _isBlock = _matched.some(({ path }) => path.includes("/project"));
  const forceJump = to.query.forceJump;
  const store = require("@/store/index").default;
  if (!isBlock || forceJump) {
    // 由于在点击登陆以后执行获取权限得方法且在next之前动态添加了路由，因此会造成当前next方法不生效，必须使用next（'/'）重新跳转，而为了避免跳转得无限循环，在重定向的路径query中添加了参数addRoyterFinish
    if (_from.path === "/login" && path === "/mainMg") {
      if (to.query.addRoyterFinish === "true") beforeEachDoc(to, _from, next);
      else {
        to.query.addRoyterFinish = "true";
        next({ ...to, replace: true });
      }
    } else {
      beforeEachDoc(to, _from, next);
    }
  } else {
    const { catalogInit } = store.state.projectMg;
    const prjId = storage.get("updatePrjcook");
    if (prjId && catalogInit !== 1) {
      const { data } = await keyCatalog.checkCatalogIsInit({
        prjId: prjId
      });
      store.dispatch("setCatalogToken", data ? "1" : "0");
      // 如果从非项目去项目下则触发在线用户统计接口
      if (_isBlock) {
        const params = {
          prjId: data ? prjId : "",
          clientType: "WEB端"
        };
        loginService
          .onlineUserSave(params);
      }
      if (data) {
        beforeEachDoc(to, _from, next);
      } else {
        next({ name: "catalogInit", replace: true });
      }
    } else {
      // 如果从非项目去项目下则触发在线用户统计接口
      if (_isBlock && prjId) {
        const params = {
          prjId: prjId,
          clientType: "WEB端"
        };
        loginService.onlineUserSave(params);
      }
      beforeEachDoc(to, _from, next);
    }
  }
}
async function beforeEachDoc(to, _from, next) {
  const store = require("@/store/index").default;
  const { path } = to;
  const hasRoles = store.state.router.hasRoles;
  if (hasRoles && getToken()) {
    // 初次登录时是没有值的
    store.dispatch("setHasRoles", false);
    const knowledgeArr = store.state.router.routerNav;
    const _isDepDoc = path.includes("/depDoc");
    // 刷新或者初次登录时 如果当前页面是部门文档有关的 才继续往下走
    if (_isDepDoc) {
      const bool = knowledgeArr.some((item) => {
        return item.path === path;
      });
      // 判断当前路由还存在不存在 如果存在就按照当前的路由继续走 不存在就找第一个
      if (bool) {
        next({ ...to, replace: false });
      } else {
        if (knowledgeArr.length) {
          next({
            path: knowledgeArr[0].path,
            replace: false
          });
        } else {
          next({
            path: "/doc",
            replace: false
          });
        }
      }
    } else {
      next({ ...to, replace: false });
    }
  } else {
    next();
  }
}
function getPermissionKey(route) {
  // 如果定义了 meta.permissionKey, 则优先取它
  if (route.meta && route.meta.permissionKey) {
    return route.meta.permissionKey;
  }
  // 针对应用路由做的特殊处理，所有改版后的应用都以/application-开头
  // if (/^\/application-/g.test(route.path)) {
  //   return route.path.slice(1);
  // }
  return route.name;
}

function gotoFirstPage(router, routes) {
  if (!routes || !routes.length) {
    return;
  }
  const location = routes[0].location || "";
  const permissionKey = routes[0].permissionKey || "";
  if (location) {
    router.replace({ path: location });
  } else {
    router.replace({ name: permissionKey });
  }
}

export async function afterEachPermiss(router, targetRoute) {
  const name = targetRoute.name;
  const targetPermissionKey = getPermissionKey(targetRoute);
  // matched 为一层一层的路径
  const matched = targetRoute.matched;
  const meta = targetRoute.meta;
  const store = require("@/store/index").default;
  const authRoutes = store.state.router.authRoutes;
  const flatRoute = store.state.router.flatRoutes;
  const flatProjectRoutes = store.state.router.flatProjectRoutes;
  if (name === "mainMg") {
    const haDes = flatRoute.some(({ permissionKey }) => permissionKey === "mainMg");
    if (haDes) {
      router.replace({ name: "mainMg" });
    } else if (authRoutes && authRoutes.length > 0) {
      gotoFirstPage(router, authRoutes);
    }
    return;
  } else if (name === "noproject" || name === "catalogInit" || meta.pname === "用户中心") {
    return;
  }

  if (matched.some((item) => item.name === "project")) {
    const moProject = flatProjectRoutes.find(({ permissionKey }) => permissionKey === targetPermissionKey);
    if (moProject) {
      gotoFirstPage(router, moProject.childList);
    } else {
      console.error("无权限：" + targetPermissionKey);
      router.replace({ name: "nopermisson" });
    }
    return;
  } else if (matched.some(({ name }) => name === "mainMg")) {
    const moSys = flatRoute.find(({ permissionKey }) => permissionKey === targetPermissionKey);
    if (moSys) {
      gotoFirstPage(router, moSys.childList);
    } else {
      console.log(targetRoute, "targetRoute");
      router.replace({
        name: "error",
        query: {
          formUrl: targetRoute.fullPath,
          formPermissionKey: targetRoute.name
        }
      });
    }
  }
}

/**
 * 路由前钩子函数
 * 检测是否需要进行登录，是否在白名单内部，是否需要请求所有权限资源
 * @param to
 * @param from
 * @param next
 * @returns {Promise<void>}
 */
export async function moduleCheck(to, from, next, routes) {
  try {
    const { query: { token: _token }} = to;

    const WHITE_LIST = getWhiteList(routes);

    const IN_WHITE_LIST = !!WHITE_LIST.find((route) => { return route.path === to.path; });
    //  是否需要登录
    const NEED_LOGIN = !IN_WHITE_LIST && !(_token || getToken());

    // 是否需要加载所有权限模块
    const NEED_MODULE_LIST = !IN_WHITE_LIST;

    if (NEED_LOGIN) {
      throw new Error("need_login");
    }
    await setUserState(next, to, NEED_MODULE_LIST);

    const isRedirct = await checkDyRoute(to, from, next);
    return isRedirct;
  } catch (error) {
    console.error(error);
    next({ name: "login" });
    return true;
  }
}
async function checkDyRoute(to, _from, next) {
  //  如果是初始路由是动态路由的地址，则没有 name 需要根据path来判断权限
  const name = to.name;
  const path = to.path;
  const store = require("@/store/index").default;
  const flatRoute = store.state.router.flatRoutes;
  const flatProjectRoutes = store.state.router.flatProjectRoutes;
  if (!name && path) {
    const isInFlatRoute = flatRoute.some((item) => item.location === path);
    const isInFlatProjectRoute = flatProjectRoutes.some((item) => item.location === path);
    if (!isInFlatRoute && !isInFlatProjectRoute) {
      next({
        name: "error",
        query: {
          formUrl: to.fullPath,
          formPermissionKey: to.name
        }
      });
      return true;
    }
  }
}
